import React, { useState, useEffect } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai'; // Import arrow up icon
import './BackToTopButton.css'; // You can style your button in a separate CSS file

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Function to handle scrolling and showing/hiding the button
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Remove the scroll event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle scrolling to the top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`back-to-top-button ${isVisible ? 'show' : 'hide'}`}
      onClick={scrollToTop}
    >
      <AiOutlineArrowUp /> {/* Arrow up icon */}
    </button>
  );
};

export default BackToTopButton;